module.exports = __webpack_public_path__ + "static/media/GH.4f42428a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GH.svg
// module id = 2157
// module chunks = 7